import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { fromRouterActions } from '@amfam/shared/utility/navigation';

import { QuickQuoteFeatureFacade } from '../+state/quick-quote-feature/quick-quote-feature.facade';

@Injectable({ providedIn: 'root' })
export class HasReplaceVehicleGuard {
  constructor(
    private quickQuoteFeatureFacade: QuickQuoteFeatureFacade,
    private store: Store
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    return this.quickQuoteFeatureFacade.replaceVehicleId$.pipe(
      map(id => {
        if (id) return true;
        else {
          const vehiceId = route.paramMap.get('id');
          this.store.dispatch(
            fromRouterActions.Go({
              path: ['policies', 'risk-selection', 'replace-vehicle-quick-quote', vehiceId]
            })
          );
          return false;
        }
      })
    );
  }
}
